import { CoreProvider } from 'contexts/Core';
import { MemberExtractProvider } from 'contexts/MemberExtract';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { Extract } from './containers';

import i18next from './locales/i18next';

function App() {
  return (
    <I18nextProvider i18n={i18next}>
      <div className="corporate-club-extract">
        <BrowserRouter>
          <CoreProvider>
            <MemberExtractProvider>
              <Extract />
            </MemberExtractProvider>
          </CoreProvider>
        </BrowserRouter>
      </div>
    </I18nextProvider>
  );
}

export default App;
